module.exports = __webpack_public_path__ + "img/building.9f8773b2.svg";